<template>
  <div>
    <v-card
      style="width: 200px; position: fixed; left: 320px; top: 60px; z-index: 5"
      elevation="2"
      height="35"
      v-if="!bPoint.xsOnly"
      class="rounded_card"
    >
      <v-card-text>
        <v-switch
          color="primary"
          v-model="showLabels"
          :label="!showLabels ? labels.showLabels : labels.hidePoiLabels"
          class="mt-1"
        ></v-switch>
        <v-btn @click="setCurrentLocation">{{ labels.currentLocation }}</v-btn>
      </v-card-text>
    </v-card>
    <v-card
      style="width: 200px; position: fixed; left: 10px; top: 140px; z-index: 10"
      elevation="2"
      tile
      height="35"
      v-else
      class="rounded_card"
    >
      <v-card-text>
        <v-switch
          color="primary"
          v-model="showLabels"
          :label="!showLabels ? labels.showLabels : labels.hidePoiLabels"
          class="mt-1"
        ></v-switch>
        <v-btn @click="setCurrentLocation">{{ labels.currentLocation }}</v-btn>
      </v-card-text>
    </v-card>
    <GmapMap
      :options="{ streetViewControl: false }"
      :center="{ lat: 44.801545, lng: 20.458796 }"
      :zoom="7"
      ref="map"
      style="width: 100%; height: 94.4vh"
      id="map"
    >
      <GmapInfoWindow
        v-for="m in markers"
        :position="m.position"
        :options="m.infoOptions"
        :opened="infoWinOpen"
      ></GmapInfoWindow>

      <GmapMarker v-for="(marker, index) in locationMarkers"
            :key="index"
            :clickable="true"
            :draggable="true"
            :position="marker.latLng"
            @click="marker.crudMarkerPopup = true"
            @mouseover="marker.labelInfoWindowState = true"
            @mouseout="marker.labelInfoWindowState = false"
            @dragend="moveMarker(marker, $event)"
          >
          <GmapInfoWindow v-if="marker.labelInfoWindowState">
            <div v-html="marker.name"></div>
          </GmapInfoWindow>
          <GmapInfoWindow v-if="marker.crudMarkerPopup" @closeclick="marker.crudMarkerPopup = false">
            <div>
              <v-btn small text @click="updateLocation(marker)">Izmeni</v-btn>
              <v-btn small text @click="deleteLocation(marker)">Obrisi</v-btn>
            </div>
          </GmapInfoWindow>
      </GmapMarker>

      <GmapMarker 
        :position="currentLocationMarker.position"
        :draggable="true"
        :icon="{
          path: currentLocationMarker.icon,
          fillColor: 'blue',
          fillOpacity: 1,
          scale: 1.5
        }"
        @dragend="currentLocationMarkerDragged">
      </GmapMarker>

    </GmapMap>

    <template>
      <v-dialog
        v-model="dialog.show"
        @keydown.esc="onCloseDialogHandler"
        max-width="380"
      >
        <template v-if="dialog.show">
          <v-card flat tile>
            <BaseDialogTitle @close="onCloseDialogHandler">
              <template v-slot:title>{{ labels.cardTitle }}</template>
            </BaseDialogTitle>
            <v-card-text>
              <MapCrudComponent
                mapType="google"
                :mapData="mapCrudData"
                @closeMapCrudComponent="handleMapCrudComponentClose"
                :submited="dialog.submited"
                :closed="!dialog.show"
                @resetSubmit="dialog.submited = false"
              ></MapCrudComponent>
            </v-card-text>
            <v-card-actions>
              <SubmitGroup
                @close="onCloseDialogHandler"
                :closeOnSubmit="closeOnSubmit"
                @submit="onSubmitDialogHandler"
              />
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </template>

      <MapLocationCrudComponent
          :locationData="mapCrudLocationData"
          :dialog='locationDialog'
          @close="onCloseLocationDialogHandler"
      >
      </MapLocationCrudComponent>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store/store'
import httpClient from '../../../api/httpClient'
import BaseGoogleMapComponent from '../BaseGoogleMapComponent'
import translate from '@/utils/genTable/multilanguageHelper.js'
import MapLocationCrudComponent from '@/components/map/MapLocationCrudComponent'
import { gmapApi } from 'vue2-google-maps'
import EventBus from '../../../event-bus'
import { globalConstants } from '@/utils/globalConstants'

export default {
  name: 'GoogleLocationComponent',
  extends: BaseGoogleMapComponent,
  components: {
    MapLocationCrudComponent
  },
  data() {
    return {
      drawingManger: null,
      bounds: null,
      labels: {
        showLabels: translate('Show Poi labels', 'maps'),
        hidePoiLabels: translate('Hide Poi labels', 'maps'),
        cardTitle: 'Poi',
        currentLocation: translate('Current location', 'realtimeMap')
      },
      locationMarkers: [],
      mapCrudLocationData: {},
      locationDialog: {
        show: false
      },
      titleInfo: null,
      currentLocationMarker: { position: { lat: 0, lng: 0}, icon: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 10.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'}
    }
  },
  computed: {
    ...mapState('map', ['pois', 'locations']),
    ...mapState('user', ['isUserDriverRole']),
    bPoint() {
      return this.$vuetify.breakpoint
    },
    google: gmapApi
  },
  async mounted() {
    var that = this
    setTimeout(() => {
      that.setupMapManager()
    }, 1000)

    const wait = timeToDelay =>
      new Promise(resolve => setTimeout(resolve, timeToDelay))
    await wait(1000)

    this.bounds = new that.google.maps.LatLngBounds()

    var url = '/pois'
    if (this.isUserDriverRole) {
      url += `?poiType=${globalConstants.pointOfInterestType.Pos}`;
      this.labels.cardTitle = 'Pos'
    }
    var pois = await httpClient.get(url)
    store.dispatch('map/clearPois')
    pois.data.forEach(poi => {
      store.dispatch('map/addPoi', poi)
      poi.coordinates.forEach(c =>
        this.bounds.extend(new that.google.maps.LatLng(c.latitude, c.longitude))
      )
    })

    var locations = await httpClient.get('/locations')
    locations.data.forEach(i => {
      let loc = {
        name: i.name,
        latLng: {
          lat: i.latitude,
          lng: i.longitude
        },
        id: i.id,
        labelInfoWindowState: false,
        crudMarkerPopup: false
      }
      that.bounds.extend(new that.google.maps.LatLng(i.latitude, i.longitude))
      that.locationMarkers.push(loc)
      store.dispatch('map/addLocation', loc)
    })

    setTimeout(() => {
      this.$refs.map.$mapObject.fitBounds(this.bounds)
    }, 300)

    EventBus.$on('POI_NAME_IN_TABLE_EVENT', this.handlePoiNameInTableEvent)
    EventBus.$on('EDIT_POI_BUTTON_EVENT', this.handleEditPoiButtonEvent)
  },
  methods: {
    handleOverlayCompleted(event) {
      if (event.type == 'circle') {
        this.handleCircleOverlayCreated(event.overlay)
      }

      if (event.type == 'polygon') {
        this.handlePolygonOverlayCreated(event.overlay)
      }

      if (event.type == 'marker') {
        this.handlePolygonMarkerCreated(event.overlay)
      }
    },
    handleCircleOverlayCreated(circle) {
      if (circle._id == undefined) {
        circle._id = ''
        circle._poiName = ''
        circle._restrictionType = ''
        circle._color = '#1CE'
      }
      circle._type = 0

      var data = {
        circle: circle
      }

      data.eventType = 'CIRCLE'
      this.handleMapCrudComponentVisibility(data)
    },
    handlePolygonOverlayCreated(polygon) {
      if (polygon._id == undefined) {
        polygon._id = ''
        polygon._poiName = ''
        polygon._restrictionType = ''
        polygon._color = '#1CE'
      }
      polygon._type = 1

      let data = {
        polygon: polygon
      }

      data.eventType = 'POLYGON'

      this.handleMapCrudComponentVisibility(data)
    },
    handlePolygonMarkerCreated(marker) {
      let data = {
        name: '',
        longitude: marker.position.lng(),
        latitude: marker.position.lat(),
        edit: false
      }
      this.mapCrudLocationData = data
      this.locationDialog.show = true
    },
    onCloseLocationDialogHandler() {
      this.locationDialog.show = false
    },
    moveMarker(marker, event) {
      let data = {
        name: marker.name,
        longitude: event.latLng.lng(),
        latitude: event.latLng.lat(),
        edit: true,
        id: marker.id
      }
      this.mapCrudLocationData = data
      this.locationDialog.show = true
    },
    updateLocation(marker) {
      let data = {
        name: marker.name,
        longitude: marker.latLng.lng,
        latitude: marker.latLng.lat,
        edit: true,
        id: marker.id
      }
      this.mapCrudLocationData = data
      this.locationDialog.show = true
    },
    deleteLocation(marker) {
      httpClient.delete(`/locations/${marker.id}`)
      store.dispatch('map/removeLocation', marker)
      let locationIndex = this.locationMarkers.indexOf(marker)
      this.locationMarkers.splice(locationIndex, 1)
    },
    setupMapManager() {
      this.drawingManger = new this.google.maps.drawing.DrawingManager({
        drawingControl: true,
        drawingControlOptions: {
          position: this.google.maps.ControlPosition.TOP_LEFT,
          drawingModes: ['circle', 'polygon', 'marker']
        },
        circleOptions: {
          editable: false,
          draggable: false
        },
        polygonOptions: {
          editable: false,
          draggable: false
        },
        markerOptions: {
          editable: false,
          draggable: false
        }
      })
      this.drawingManger.setMap(this.$refs.map.$mapObject)

      this.google.maps.event.addListener(
        this.drawingManger,
        'overlaycomplete',
        event => {
          this.drawingManger.setDrawingMode(null)

          this.handleOverlayCompleted(event)
        }
      )
    },
    handlePoiNameInTableEvent(poi) {
      var that = this
      let bounds = new this.google.maps.LatLngBounds()
      poi.coordinates.forEach(x => {
        bounds.extend(new that.google.maps.LatLng(x.latitude, x.longitude))
      })
      this.$refs.map.$mapObject.fitBounds(bounds)

      if (this.titleInfo) {
        this.titleInfo.close(this.$refs.map.$mapObject)
      }
      this.titleInfo = null
      this.titleInfo = new this.google.maps.InfoWindow({
        content: `<h3>${poi.name}</h3>`
      })

      this.titleInfo.setPosition({
        lat: poi.coordinates[0].latitude,
        lng: poi.coordinates[0].longitude
      })
      this.titleInfo.open(this.$refs.map.$mapObject)
    },
    handleEditPoiButtonEvent(data) {
      if (data.type == 0) {
        this.handleEditCirclePoiButtonEvent(data)
      } else if (data.type == 1) {
        this.handleEditPolygonPoiButtonEvent(data)
      }
    },
    handleEditCirclePoiButtonEvent(data) {
      let circle = {
        circle: {
          _id: data.id,
          _poiName: data.name,
          _poiTime: data.allowedStayMinutes,
          _color: data.color,
          _type: data.type,
          _restrictionType: data.restriction,
          _vehicleIds: data.vehicleIds,
          _mRadius: data.radius,
          _latlng: {
            lat: data.coordinates[0].latitude,
            lng: data.coordinates[0].longitude
          },
          _contacts: data.contacts,
          _hasParking: data.hasParking,
          _objectType: data.objectType,
          _unloadPlaceType: data.unloadPlaceType,
          _pointOfInterestType: data.pointOfInterestType,
          _partnerCode: data.partnerCode,
          _hasRamp: data.hasRamp,
          _hasForklift: data.hasForklift,
          _specialPermitRequired: data.specialPermitRequired,
          _posClientId: data.posClientId,
          _businessUnitId: data.businessUnitId
        },
        eventType: 'CIRCLE',
        dataFromEditButton: false
      }

      this.handleMapCrudComponentVisibility(circle)
    },
    handleEditPolygonPoiButtonEvent(data) {
      let coor = []
      data.coordinates.forEach(x => {
        coor.push({
          lat: x.latitude,
          lng: x.longitude
        })
      })
      let polygon = {
        polygon: {
          _id: data.id,
          _poiName: data.name,
          _poiTime: data.allowedStayMinutes,
          _color: data.color,
          _type: data.type,
          _restrictionType: data.restriction,
          _vehicleIds: data.vehicleIds,
          _mRadius: '',
          _latlngs: coor
        },
        eventType: 'POLYGON',
        dataFromEditButton: true
      }

      this.handleMapCrudComponentVisibility(polygon)
    },
    setCurrentLocation() {
      let that = this

      navigator.geolocation.getCurrentPosition(function(position) {
        that.currentLocationMarker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }

        that.$refs.map.$mapObject.panTo(that.currentLocationMarker.position)
        that.$refs.map.$mapObject.setZoom(19)
      }, function(error) {
        store.dispatch(
            'notification/add',
            {
              type: 'error',
              message: `ERROR(${error.code}: ${error.message})`
            },
            {
              root: true
            }
          )
      }, {
        enableHighAccuracy: true,
        maximumAge: 10000,
        timeout: 5000,
      })
    },
    currentLocationMarkerDragged(event) {
      this.currentLocationMarker.position = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      }
    }
  },
  watch: {
    showLabels: {
      handler() {
        this.locationMarkers.forEach(i => {
          i.labelInfoWindowState = this.showLabels
        })
      }
    }
  }
}
</script>
<style scoped>
.gm-style-iw {
  width: 80px;
  min-width: 150px;
}
.rounded_card {
  border-radius: 2px;
}
</style>
